import { format } from 'date-fns';
import { findKey } from 'lodash';
import { useSelector } from 'react-redux';

import { timezoneMap } from '@swf/account';
import { select } from '@swf/core/store';

interface Timezone {
  timeZone: string;
  timeZoneName: string;
  timeZoneId?: number;
}

const useTimezone = (nativeClientTz?: string): Timezone => {
  let timeZoneId = useSelector(select.account.getTimezone);

  if (nativeClientTz) {
    timeZoneId = timezoneMap[nativeClientTz]?.id;
  }

  if (timeZoneId !== undefined) {
    const timeZone = findKey(timezoneMap, ({ id }) => id === timeZoneId) || 'UTC';
    const timeZoneName = timezoneMap[timeZone].canonicalName;
    return { timeZone, timeZoneName, timeZoneId };
  }

  const timeZone = format(new Date(), 'O');
  const timeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return { timeZone, timeZoneName };
};

export default useTimezone;
